import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { FiEdit, FiTrash2 } from 'react-icons/fi';
import api from '../../services/api';
import FeedLayout from '../Includes/FeedLayout';
import Perfil from '../../assests/avatar.png';
import { calculaTempo } from '../../global';

import './styles.css';

export default function Classifieds() {
  const history = useHistory();
  const { t } = useTranslation();
  const sentinelRef = useRef(null);
  const loadingRef = useRef(false);

  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);

  const BASE_URL = sessionStorage.getItem('BASE_URL');
  const USER_EMAIL = sessionStorage.getItem('email');
  const USER_TOKEN = sessionStorage.getItem('token');

  useEffect(() => {
    let cancelled = false;
    loadingRef.current = true;
    setLoadingMore(true);

    api.get(`/v6/classifieds?page=${page}`, {
      headers: {
        USER_EMAIL,
        USER_TOKEN,
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (cancelled) return;
      const data = Array.isArray(response.data) ? response.data : [];
      setPosts((prev) => (page === 1 ? data : prev.concat(data)));
      setHasMore(data.length > 0);
    }).catch(() => {
      if (!cancelled) history.push('/');
    }).finally(() => {
      if (!cancelled) {
        loadingRef.current = false;
        setLoadingMore(false);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [USER_EMAIL, USER_TOKEN, history, page]);

  useEffect(() => {
    const el = sentinelRef.current;
    if (!el) return undefined;
    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      if (loadingRef.current || !hasMore) return;
      setPage((current) => current + 1);
    }, { rootMargin: '240px' });
    observer.observe(el);
    return () => observer.disconnect();
  }, [hasMore, posts.length]);

  function continuarLendo(anuncioID) {
    sessionStorage.setItem('adFrom', 'classifieds');
    history.push('/meus-anuncios/detalhe/' + anuncioID);
  }
  function alterarAnuncio(postId) {
    history.push(`/meus-anuncios/alterar/${postId}`);
  }
  async function excluirAnuncio(id) {
    var excl = window.confirm(t('pages.classifieds.wantDelete'));
    if (!excl) {
      return false;
    }
    var axios = require('axios');
    var FormData = require('form-data');
    var data = new FormData();

    var config = {
      method: 'delete',
      url: BASE_URL + `/v6/classifieds/${id}`,
      headers: {
        USER_EMAIL,
        USER_TOKEN,
      },
      data,
    };
    await axios(config)
      .then(function () {
        setPosts((prev) => prev.filter((post) => post.id !== id));
      })
      .catch(function () {});
  }
  function mostrarEditar(post) {
    if (post.user_info && post.user_info.id === parseInt(sessionStorage.getItem('id'), 10)) {
      return (
        <div className="edit">
          <Link to="#" onClick={() => alterarAnuncio(post.id)}>
            <FiEdit />{t('pages.classifieds.edit')}
          </Link>
          <Link className="icoExcluir" to="#" onClick={() => excluirAnuncio(post.id)}>
            <FiTrash2 className="icoExcluir" />{t('pages.classifieds.delete')}
          </Link>
        </div>
      );
    }
    return null;
  }

  return (
    <FeedLayout active="classifieds">
      <div className="classificados-container">
        <div className="feed-top">{t('pages.includes.filters.classified')}</div>
        <section className="body">
          <ul>
            {posts.map((post) => {
              const avatar = post.user_info && post.user_info.avatar && post.user_info.avatar.medium
                ? post.user_info.avatar.medium
                : Perfil;
              const city = (post.city_info && post.city_info.name) || '';
              const state = (post.state_info && post.state_info.acronym) || '';
              return (
                <li key={post.id}>
                  {mostrarEditar(post)}
                  <p className="nomeProf">
                    <img className="imgProf" src={avatar} alt="" />
                    <span>
                      <span className="nome">{post.user_info && post.user_info.name}</span>
                      <span className="tempo"> · {calculaTempo(post.created_at)}</span>
                    </span>
                  </p>
                  <p className="tags">
                    {post.category ? <span>#{post.category}</span> : null}
                  </p>
                  <p className="title">{post.title}</p>
                  <p className="value">{Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(post.value)}</p>
                  {post.image_url ? (
                    <p className="img">
                      <img
                        className="img_url"
                        src={post.image_url}
                        alt=""
                        onClick={() => continuarLendo(post.id)}
                      />
                    </p>
                  ) : null}
                  <p className="cidade">{city}{city && state ? '/' : ''}{state}</p>
                  <p className="description">{post.description}</p>
                  <p className="observation">{post.observation}</p>
                  <p className="lermais">
                    <Link
                      to={'/meus-anuncios/detalhe/' + post.id}
                      onClick={() => sessionStorage.setItem('adFrom', 'classifieds')}
                    >
                      {t('pages.classifieds.more')}
                    </Link>
                  </p>
                </li>
              );
            })}
          </ul>
          <div className="feed-sentinel" ref={sentinelRef}>
            {loadingMore && <span>Carregando mais classificados…</span>}
            {!loadingMore && !hasMore && posts.length > 0 && (
              <span>Você viu os classificados mais recentes</span>
            )}
          </div>
        </section>
      </div>
    </FeedLayout>
  );
}
